import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { NgCommonModule } from '@principle-theorem/ng-shared';

@Component({
  selector: 'pr-statistic',
  templateUrl: './statistic.component.html',
  styleUrl: './statistic.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col items-start justify-center' },
  imports: [NgCommonModule, MatTooltip, MatIcon],
})
export class StatisticComponent {
  label = input.required<string>();
  tooltip = input<string>();
}
